import https from "./https"
import store from "@/store"

const organization = store.state.general.organization;

const collection = {
  getCollections(params) {
    return https.get(`admin/organizations/${organization.id}/collections`, { params });
  },
  async getOptionsForBranch(id, branchId) {
    return https.get(`admin/organizations/${organization.id}/collections/${id}/branch/${branchId}`)
  },
  async getOptionsForStaff(id, staffId) {
    return await this.getItems(id, { is_all: true, staff_id: staffId })
  },
  deleteCollection(id) {
    return https.delete(`admin/organizations/${organization.id}/collections/${id}`);
  },
  createCollection(params) {
    return https.post(`admin/organizations/${organization.id}/collections`, params);
  },
  updateCollection(id, params) {
    return https.put(`admin/organizations/${organization.id}/collections/${id}`, params);
  },
  getCollection(id, params) {
    return https.get(`admin/organizations/${organization.id}/collections/${id}`, { params });
  },
  getItems(id, params) {
    return https.get(`admin/organizations/${organization.id}/collections/${id}/items`, { params });
  },
  createItem(collectionId, params) {
    return https.post(`admin/organizations/${organization.id}/collections/${collectionId}/items`, params);
  },
  uploadCollectionItems(collectionId, formData) {
    return https.post(
      `admin/organizations/${organization.id}/collections/${collectionId}/import-items`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  },
  exportSampleExcel(collectionId) {
    return https.get(
      `admin/organizations/${organization.id}/collections/${collectionId}/sample-excel`,
      { responseType: 'blob' }
    );
  },
  deleteItem(collectionId, itemId) {
    return https.delete(`admin/organizations/${organization.id}/collections/${collectionId}/items/${itemId}`);
  },
  batchDeleteItems(collectionId, params) {
    return https.delete(`admin/organizations/${organization.id}/collections/${collectionId}/items/batch-delete`, { params });
  },
  getItem(collectionId, itemId) {
    return https.get(`admin/organizations/${organization.id}/collections/${collectionId}/items/${itemId}`);
  },
  upadteItem(collectionId, itemId, params) {
    return https.put(`admin/organizations/${organization.id}/collections/${collectionId}/items/${itemId}`, params);
  },
  syncToBranch(params) {
    return https.put(`admin/organizations/${organization.id}/collections/sync-branch-collections`, params);
  },
  getRelationsItems(collectionId, params) {
    return https.get(`admin/organizations/${organization.id}/collections/${collectionId}/branch/get-relations-items`, { params });
  },
  syncToSingleBranch(collectionId, params) {
    return https.post(`admin/organizations/${organization.id}/collections/${collectionId}/sync-single-branch-collections`, params);
  },
  changeRelationIsEnabled(collectionId , params) {
    return https.put(`admin/organizations/${organization.id}/collections/${collectionId}/batch-update-relation-is-enabled`, params);
  },
  getCollectionItemStaffs(collectionId, itemId, params) {
    return https.get(`admin/organizations/${organization.id}/collections/${collectionId}/item/${itemId}/staffs`, { params });
  },
  createCollectionItemStaff(collectionId, itemId, data) {
    return https.post(`admin/organizations/${organization.id}/collections/${collectionId}/item/${itemId}/staffs`, data);
  },
  getCollectionItemStaff(collectionId, itemId, relationId) {
    return https.get(`admin/organizations/${organization.id}/collections/${collectionId}/item/${itemId}/staffs/${relationId}`);
  },
  updateCollectionItemStaff(collectionId, itemId, relationId, data) {
    return https.put(`admin/organizations/${organization.id}/collections/${collectionId}/item/${itemId}/staffs/${relationId}`, data);
  },
  deleteCollectionItemStaff(collectionId, itemId, relationId) {
    return https.delete(`admin/organizations/${organization.id}/collections/${collectionId}/item/${itemId}/staffs/${relationId}`);
  }
}

export default collection
